/**
 * AI Provider button for navbar - shows connection status and opens modal
 */

import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button.tsx";
import { useAuth } from "@/hooks/useAuth.ts";
import { getProviderConfig } from "@/lib/ai/config.ts";
import { Sparkles } from "lucide-react";

interface AIProviderButtonProps {
  onClick: () => void;
}

export function AIProviderButton({ onClick }: AIProviderButtonProps) {
  const { t } = useTranslation();
  const { isAuthenticated, provider, isExpired } = useAuth();

  if (!isAuthenticated) {
    return (
      <Button onClick={onClick} size="sm" variant="outline" className="gap-2 text-xs">
        <Sparkles className="h-4 w-4" />
        {t("auth.connect")}
      </Button>
    );
  }

  if (isExpired) {
    return (
      <Button
        onClick={onClick}
        size="sm"
        variant="outline"
        className="gap-2 text-xs border-destructive text-destructive"
      >
        <Sparkles className="h-4 w-4" />
        {t("auth.expired")}
      </Button>
    );
  }

  const providerName = provider ? getProviderConfig(provider)?.name : "Unknown";
  const displayText = providerName;

  return (
    <Button
      onClick={onClick}
      size="sm"
      variant="outline"
      className="gap-2 text-xs max-w-[180px]"
    >
      <div className="h-2 w-2 rounded-full bg-emerald-500" />
      <span className="truncate">{displayText}</span>
    </Button>
  );
}
